<template>
	<div class="footer" id="lrfooter">
		<div class="footer_content">
			<div class="footer_left">
				<div class="footer_company">
					<img :src="footerLogo"/>
					<div class="footer_company_name">
						<span class="footer_company_name_text">{{companyName}}</span>
						<span class="footer_company_name_text2">{{companyNameEn}}</span>
					</div>
				</div>
				<div class="footer_concat">
					<div class="footer_tel">
						<span class="span_text">座机:{{companyTel}}</span>
					</div>
					<div class="footer_phone">
						<span class="span_text">电话:{{companyPhone}}</span>
					</div>
					<div class="footer_email">
						<span class="span_text" >邮箱:{{companyEmail}}</span>
					</div>
				</div>
			</div>
			<div class="footer_right">
				<div class="footer_right_qr">
					<img src="https://website2024.oss-cn-beijing.aliyuncs.com/pc/img_qrcode.png" />
				</div>
				<span class="footer_right_text">扫码关注了然</span>
			</div>
		</div>
	</div>
	
</template>

<script>
export default {
	name: "lrFooter",
	props: {
		footerLogo: {
			type:String,
			default:"data:image/png;base64,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"
		},
		companyName: {
			type:String,
			default:""
		},
		companyNameEn: {
			type:String,
			default:""
		},
		companyTel: {
			type: String,
			default: ""
		},
		companyPhone: {
			type: String,
			default: ""
		},
		companyEmail: {
			type: String,
			default: ""
		}
	},

	mounted() {
		/* let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
		}); */
	},

	methods: {
		toPages(url) {
			this.$router.push(url);
		},
		toNews(url) {
			this.$router.push(url);
		},
	},
};
</script>
<style scoped>

.footer {
	width: 100%;
	height: 23rem;
	background: url(https://website2024.oss-cn-beijing.aliyuncs.com/pc/bg_footer.png) 100% no-repeat;
	background-size: 100% 100%;
}
.footer_content {
	/* width: 75rem; */
	margin: 0 auto;
	display: flex;
	padding-left: 17rem;
	padding-right: 15rem;
	height: 100%;
}
.footer_left {
	width: 75%;
}
.footer_company {
	padding-top: 4.1875rem;
	display: flex;
	flex-direction: row;
	/* justify-content: space-between; */
}
.footer_company_name {
	display: flex;
	flex-direction: column;
	padding-top: 0.625rem;
	padding-left: 1.0625rem;
}
.footer_company_name_text {
	font-family: DingTalk JinBuTi, DingTalk JinBuTi;
	font-weight: 400;
	font-size: 1.5rem;
	color: #FFFFFF;
	line-height: 1.8125rem;
	text-align: left;
	font-style: normal;
	text-transform: none;
}
.footer_company_name_text2 {
	font-family: DingTalk JinBuTi, DingTalk JinBuTi;
	font-weight: 400;
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 1.0625rem;
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.footer_concat {
	padding-top: 4.25rem;
	display: flex;
	flex-direction: column;
}

.footer_tel {
	display: flex;
	flex-direction: row;
	/* width: 20.375rem; */
	margin-top: 0.875rem;
}
.span_text {
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	font-size: 1.125rem;
	color: #FFFFFF;
	line-height: 1.5rem;
}
.span_text2 {
	margin-top: 0.6875rem;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	font-size: 1.875rem;
	color: #FFFFFF;
	line-height: 2.5rem;
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.footer_phone {
	display: flex;
	flex-direction: column;
	/* width: 17.9375rem; */
	margin-top: 0.875rem;
}

.footer_email {
	display: flex;
	flex-direction: column;
	/* width: 20.375rem; */
	margin-top: 0.875rem;
}

.footer_right{
	display: flex;
	flex-direction: column;
	width: 25%;
	/* text-align: center; */
	align-items: flex-end;
	justify-content: center;
}
.footer_right_qr {
	width: 8.0625rem;
	height: 8.0625rem;
	background: #FFFFFF;
	border-radius: 11px 11px 11px 11px;
}
.footer_right_text{
	margin-top: 1.3125rem;
	margin-right: 0.625rem;
	
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	font-size: 1.125rem;
	color: #FFFFFF;
	line-height: 1.5rem;
	text-align: left;
	font-style: normal;
	text-transform: none;
}
</style>
